function launchCountdown() {

  console.log("launchCountdown triggered!");
  // NOTE: the liquid logic omits the entire ProductForm whenever the launch countdown tag is present AND the date is in the future
  // this is to make it impossible for sneaky users to use browser DevTools to show the Add to cart button before the timer runs out

  // yes I'm talking about YOU lol, stop reading my code

  // Server will tell us how long to count down for
  var InitialRemainingTime = document.getElementById("launch-countdown").dataset.remainingTime;

  // handle unexpected situation where we don't have that info from the server side code (defaults to NOT showing countdown)
  if (!InitialRemainingTime) {
      console.log("Countdown timer remainingTime is not set! Check buy-buttons code");
      InitialRemainingTime = 0;
  }
  // If the count down date is in the future, initiate the countdown
  if (InitialRemainingTime > 0) {
      console.log("Product not yet launched, initiating countdown");
      createInterval(updateCountdown, parseInt(InitialRemainingTime), 1000);
  } else {
      console.log("Product has already launched, not showing countdown");
  }

} // end of launchCountdown function

function createInterval(f, remainingTime, interval) {
  // Use an object to store remainingTime so it can be modified by reference
  var timeObj = { remaining: remainingTime };
  var x = setInterval(function () {
      f(timeObj, x);
  }, interval);
} // end of createInterval function

function updateCountdown(timeObj, x) {

  console.log(timeObj.remaining);
  // If the count down is finished, hide the countdown and refresh the page

  if (timeObj.remaining < 0) {

      clearInterval(x);

      // refresh the page (which should include the buy buttons now)
      location.reload();

  } else {

      // If the countdown is still in the future, update the days / hours / minutes / seconds
      var days = Math.floor(timeObj.remaining / (60 * 60 * 24));
      document.getElementById("launch-days").innerHTML = pad(days, 2, "0");
      var hours = Math.floor((timeObj.remaining % (60 * 60 * 24)) / (60 * 60));
      document.getElementById("launch-hours").innerHTML = pad(hours, 2, "0");
      var minutes = Math.floor((timeObj.remaining % (60 * 60)) / 60);
      document.getElementById("launch-mins").innerHTML = pad(minutes, 2, "0");
      var seconds = Math.floor((timeObj.remaining % 60) / 1);
      document.getElementById("launch-secs").innerHTML = pad(seconds, 2, "0");
      
      // IMPORTANT: Decrement the remaining time by 1 second
      timeObj.remaining--;
  }

} // end of updateCountdown

function pad(n, width, z) {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}